/** How a section and a student on My LA positions are named and addressed. */
export const sectionLabel = (position) =>
    `${position.subject} ${position.courseNumber}, section ${position.section}`;

export const positionPath = (applicationId, candidacyId) =>
    candidacyId
        ? `/my-positions/${applicationId}/${candidacyId}`
        : `/my-positions/${applicationId}`;
